import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function StorageReports() {
  const { user } = useUser()
  let view = contentLayout[modules.StorageReports]
  if (user.permissions.views.length && !user.permissions.views.join().includes(modules.StorageReports.toLowerCase())) {
    view = Forbidden
  }
  return (
    <Index content={view} module={modules.StorageReports}></Index>
  )
}

export default StorageReports
